import { Button } from 'components/ui';
import { useModal } from 'contexts/modal';
import { useInfo } from 'contexts/info';
import { FormattedMessage } from 'react-intl';
import Edit from 'components/place/modal/edit';

const EditButton = ({ place, space, refetch, size = 'medium' }) => {
  const { addModal, removeModal } = useModal();
  const setInfo = useInfo();

  return (
    <Button
      size={size}
      disabled={!space.adminRole}
      variant="contained"
      onClick={() => {
        addModal(
          <Edit
            place={place}
            onSuccess={() => {
              refetch();
              removeModal();
              setInfo('info.place.edited');
            }}
            handleClose={() => removeModal()}
          />
        );
      }}
    >
      <FormattedMessage id="button.edit" />
    </Button>
  );
};

export default EditButton;
